import { Layout } from "antd";
import ApplicantTrackingBody from "../../components/applicant-tracking/ApplicantTrackingBody";

const ApplicantTracking = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", paddingLeft: "20px", paddingRight: "20px" }} className="max-w-6xl w-full mx-auto">
        <ApplicantTrackingBody />
      </Layout>
    </>
  );
};

export default ApplicantTracking;
